import { createClient } from '@sanity/client';

const sanityClient = createClient({
  projectId: '7qflttjf',
  dataset: 'production',
  useCdn: true,
  apiVersion: '2023-05-01' // Always specify an API version
});

export default sanityClient;
